import productStickersPdfGenerate from './../../pages/static/pdf/product-stickers/product-stickers-pdf-generate_all'
import {JadCupImg, emptyImg} from '../../services/others/assets'
import {ApiRequest} from '../../services/api/api'
import {IStickerPdf} from '../../services/model/IStickerPdf'
import moment from 'moment'

// interface Data {
//     barcode: any;
//     productName: any;
//     logoType: any;
//     logoUrl: any;
//     logoBase64: string;
//     productCode: any;
//     packaging: string;
//     madeInNz: string;
//     testLogo: string;
//     manufactureDate: null;
//   }
  
const ProductDetailInPdf =  (boxes:any[],logoBase64:any): IStickerPdf[] => {
  const productDetail: IStickerPdf[] = boxes.map( (res, index) => {
    let data = res;


    const barCode = data.barCode;
    const product = data.product.productName;
    const logoType = data.product.logoType;
    const logoUrl = data.product.logoUrl;
    const productCode = data.product.productCode;



    // 优先从 data.custProductCode 获取，如果没有则从 data.product.custProductCode 获取
    const custProductCode = data.custProductCode || data.product?.custProductCode || data.product.productCode;



    const packaging = data.product?.baseProduct?.packagingType?.sleevePkt + 'pcs X '
                    + data.product?.baseProduct?.packagingType?.sleeveQty + 'pk';
    const sleeveQty = data.product?.baseProduct?.packagingType?.sleeveQty;
    const sleevePkt = data.product?.baseProduct?.packagingType?.sleevePkt;
    const madeInNz = (data.product.logoType != 3) ? 'Made In New Zealand' : '';
    const grossWeigh = data.product?.baseProduct?.grossWeigh;
    const cartonLength = data.product?.baseProduct?.cartonLength;
    const cartonWidth = data.product?.baseProduct?.cartonWidth;
    const cartonHeight = data.product?.baseProduct?.cartonHeight;
    // 安全处理 manufactureDate
    let manufactureDate:any;
    if (data.createdAt) {
      // 尝试解析 createdAt，如果格式不正确则补充 .000Z
      const createdAtStr = String(data.createdAt);
      manufactureDate = moment.utc(createdAtStr.includes('Z') || createdAtStr.includes('+') ? createdAtStr : createdAtStr + '.000Z').local();
    } else {
      manufactureDate = moment.utc().local();
    }
    console.log("manufactureDate123",manufactureDate);
    const quantity = data.quantity

    return {
      barcode: barCode,
      productName: product,
      logoType: logoType,
      logoUrl: logoUrl,
      logoBase64: logoBase64,
      productCode: productCode,
      custProductCode: custProductCode,
      packaging: packaging,
      sleeveQty: sleeveQty,
      sleevePkt: sleevePkt,
      madeInNz: madeInNz,
      testLogo: JadCupImg,
      manufactureDate: manufactureDate,
      quantity:quantity,
      batchNumber: data.workOrderNo || "",
      grossWeigh: grossWeigh,
      cartonLength: cartonLength,
      cartonWidth: cartonWidth,
      cartonHeight: cartonHeight
    };
  });

  console.log("=== ProductDetailInPdf 完成 ===");
  console.log("返回的 productDetail 数量:", productDetail.length);
  console.log("返回的 productDetail 数据:", productDetail);
  return productDetail;
}

const PdfStickService = (boxes:any[],logoBase64:any) => {
    // let barcode: any[] = [];
    // const productId="";
    const  ProductDetail = ProductDetailInPdf(boxes,logoBase64)
    productStickersPdfGenerate(ProductDetail, 'print')

}

export default PdfStickService
